interface ApprovedOnBoardingDocumentFS1Props {
  onClose: () => void;
  onSubmit: () => void;
}

const ApprovedOnBoardingDocumentFS1 = ({
  onClose,
  onSubmit,
}: ApprovedOnBoardingDocumentFS1Props) => {
  return (
    <div className="tw-relative">
      {/* Main Content */}
      <div className="tw-p-6 tw-mt-[147px] tw-gap-6 tw-flex-col tw-flex">
        <div className="tw-flex tw-gap-6">
          <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB] tw-w-[20%] tw-h-[170px]">
            <div className="tw-flex tw-justify-between tw-items-center tw-px-6 tw-py-4">
              <h2 className="tw-text-base tw-font-semibold tw-text-[#232323]">
                SOP
              </h2>
            </div>
            <hr />
            <div className="tw-px-6 tw-py-4 tw-ml-5">
              <ul>
                <li className="tw-text-[#232323] tw-text-sm tw-font-medium tw-list-disc">
                  Facility Requested Correct?
                </li>
              </ul>
            </div>
          </div>
          <div className="tw-w-[60%] tw-flex tw-flex-col tw-gap-6">
            <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB]">
              <div className="tw-flex tw-justify-between tw-items-center tw-p-4">
                <h2 className="tw-text-base tw-font-semibold">
                  Primary Contact Details{" "}
                </h2>
              </div>
              <hr />
              <div className="tw-grid md:tw-grid-cols-2 sm:tw-grid-cols-12 tw-grid-cols-12 tw-gap-8 tw-p-8">
                <div className="tw-flex tw-flex-col tw-gap-1">
                  <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                    Name
                  </span>
                  <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                    John Doe
                  </h4>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-1">
                  <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                    Email
                  </span>
                  <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                    johndoe@gmail.com
                  </h4>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-1">
                  <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                    Contact Number
                  </span>
                  <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                    +27 21 123 4567
                  </h4>
                </div>
              </div>
            </div>
            <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB]">
              <div className="tw-flex tw-justify-between tw-items-center tw-p-4">
                <h2 className="tw-text-base tw-font-semibold">
                  Company Details
                </h2>
              </div>
              <hr />
              <div className="tw-grid md:tw-grid-cols-2 sm:tw-grid-cols-12 tw-grid-cols-12 tw-gap-8 tw-p-8">
                <div className="tw-flex tw-flex-col tw-gap-1">
                  <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                    Registered Company Name
                  </span>
                  <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                    ZuluTech Innovations (Pty) Ltd
                  </h4>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-1">
                  <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                    Trading As
                  </span>
                  <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                    ZuluTech Solutions
                  </h4>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-1">
                  <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                    Commodity Type
                  </span>
                  <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                    Software Solutions
                  </h4>
                </div>
              </div>
            </div>
            <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB]">
              <div className="tw-flex tw-justify-between tw-items-center tw-p-4">
                <h2 className="tw-text-base tw-font-semibold">
                  Primary Contact Details{" "}
                </h2>
              </div>
              <hr />
              <div className="tw-grid md:tw-grid-cols-2 sm:tw-grid-cols-12 tw-grid-cols-12 tw-gap-8 tw-p-8">
                <div className="tw-flex tw-flex-col tw-gap-1">
                  <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                    Name
                  </span>
                  <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                    John Doe
                  </h4>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-1">
                  <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                    Email
                  </span>
                  <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                    johndoe@gmail.com
                  </h4>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-1">
                  <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                    Contact Number
                  </span>
                  <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                    +27 21 123 4567
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB] tw-w-[20%] tw-h-[400px]">
            <div className="tw-flex tw-justify-between tw-items-center tw-px-6 tw-py-4">
              <h2 className="tw-text-base tw-font-semibold tw-text-[#232323]">
                Inputs
              </h2>
            </div>
            <hr />
            <div className="tw-px-6 tw-py-4">
              <div className="tw-mb-3">
                <span className="tw-text-[#414651] tw-text-sm tw-font-medium">
                  Registered Company Name
                </span>
                <h2 className="tw-text-[#232323] tw-text-base tw-font-medium">
                  ZuluTech Innovations (Pty) Ltd
                </h2>
              </div>
              <div className="tw-mb-3">
                <span className="tw-text-[#414651] tw-text-sm tw-font-medium">
                  Trading As
                </span>
                <h2 className="tw-text-[#232323] tw-text-base tw-font-medium">
                  ZuluTech Solutions
                </h2>
              </div>
              <div className="tw-mb-3">
                <span className="tw-text-[#414651] tw-text-sm tw-font-medium">
                  Commodity Type
                </span>
                <h2 className="tw-text-[#232323] tw-text-base tw-font-medium">
                  Software Solutions
                </h2>
              </div>
              <div className="tw-mb-3">
                <span className="tw-text-[#414651] tw-text-sm tw-font-medium">
                  Facility Required
                </span>
                <h2 className="tw-text-[#232323] tw-text-base tw-font-medium">
                  Yes
                </h2>
              </div>
              <div className="tw-mb-3">
                <span className="tw-text-[#414651] tw-text-sm tw-font-medium">
                  Facility Requested Amount
                </span>
                <h2 className="tw-text-[#232323] tw-text-base tw-font-medium">
                  S 300 000
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovedOnBoardingDocumentFS1;
